import { httpInstancePublicProvider } from "@/services/httpInstance";

const getCommercialCategories = async () => {
  let endpoint = `crm_helper/v1/crm/get_commercial_categories`;

  try {
    const response = await httpInstancePublicProvider.get(endpoint);

    return response.data;
  } catch (error: any) {
    console.error("❌ Error en getCommercialCategories:", {
      message: error?.message,
      status: error?.response?.status,
      data: error?.response?.data,
    });
    return error?.response;
  }
};

export default getCommercialCategories;
